import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Game from '../scenes/Game';
import UIAssetKeys from '../UIAssetKeys';
import NumberDisplay from './NumberDisplay';

export default class NumberChoiceMenu extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Game} scene 
   */
  constructor(scene) {
    super(scene);

    this.delegate = scene;

    /** @type {NumberDisplay[]} */
    this.activeButtons = [];
    this.buttonContainer = this.scene.add.container();

    this.choiceWidth = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._outside_circle).realWidth;
    this.choiceHeight = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._outside_circle).realHeight;
  }

  setMenu (numbers) {
    this.resetMenu();

    let padding = 20;
    const len = numbers.length;
    let adjustX = 32;
    if (len === 9) {
      adjustX = 42;
      padding = 10;
    }

    const adjustY = 200;

    const startX = (this.scene.scale.width / 2) - (this.choiceWidth * len / 2) - (this.choiceWidth / 2) + adjustX;
    const startY = this.choiceHeight + 30;
    let x = 0; let y = 0;
    for (let i = 0; i < len; i++) {
      const item = new NumberDisplay(this.scene);
      const shadow = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._orb_shadow, this).setAlpha(0)
        .setScale(0);
      this.add(shadow);
      this.add(item);

      x = startX + (i * this.choiceWidth) + (padding * i);
      y = startY;

      item.reset(numbers[i],x,y, shadow);
      item.y -= adjustY;
      this.activeButtons.push(item);

      ABCyaPhaser.Container.setContainerInteractive(item,false);
      this.scene.input.setDraggable(item, true);
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,() => this.startDrag(item), this);
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG, () => this.doDrag(item), this);
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.stopDrag(item), this);

      ABCyaPhaser.Tweens.addTween(item, 1000, { y: item.y + adjustY, delay: i * 150, onUpdate: () => item.updateShadow(item.y,startY) }, Phaser.Math.Easing.Bounce.Out);
    }
  }

  resetMenu () {
    const len = this.activeButtons.length;
    for (let i = 0; i < len; i++) {
      this.activeButtons[i].off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.activeButtons[i].off(Phaser.Input.Events.GAMEOBJECT_DRAG);
      this.activeButtons[i].off(Phaser.Input.Events.GAMEOBJECT_DRAG_END);
      this.activeButtons[i].destroy();
    }
    this.activeButtons = [];
  }

  /**
   * 
   * @param {NumberDisplay} sender 
   */
  startDrag (sender) {
    const btn = sender;
    btn.offsetX = this.scene.input.activePointer.x - btn.x;
    btn.offsetY = this.scene.input.activePointer.y - btn.y;
    btn.shadow.setVisible(false);

    if (btn.parentContainer) {
      btn.parentContainer.bringToTop(btn);
    }
    else {
      this.scene.children.bringToTop(btn);
    }
  }

  doDrag (sender) {
    const btn = sender;
    btn.x = this.scene.input.activePointer.x - btn.offsetX;
    btn.y = this.scene.input.activePointer.y - btn.offsetY;
  }

  /**
   * 
   * @param {NumberDisplay} sender 
   */
  stopDrag (sender) {
    const btn = sender;
    this.delegate.checkChoiceDrop(btn);
  }

  findPlacedItem (index) {
    const len = this.activeButtons.length;
    let placedItem = null;
    for (let i = 0; i < len; i++) {
      if (this.activeButtons[i].placedIndex === index) {
        placedItem = this.activeButtons[i];
      }
    }
    return placedItem;
  }
}